import { render, staticRenderFns } from "./accountHeader.vue?vue&type=template&id=59484b76"
import script from "./accountHeader.vue?vue&type=script&lang=js"
export * from "./accountHeader.vue?vue&type=script&lang=js"
import style0 from "./accountHeader.vue?vue&type=style&index=0&id=59484b76&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59484b76')) {
      api.createRecord('59484b76', component.options)
    } else {
      api.reload('59484b76', component.options)
    }
    module.hot.accept("./accountHeader.vue?vue&type=template&id=59484b76", function () {
      api.rerender('59484b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/accountHeader.vue"
export default component.exports